import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

const getTherapistRatingQueryKey = () => ["getTherapistRating"] as const;

export const useGetTherapistRating = () => {
  const client = useApiClient();

  return useQuery(getTherapistRatingQueryKey(), () => client.getTherapistRating());
};
